export const path = 'https://api.gekkogame.io'
